<template>
    <div class="sidebar">
        <div>
            <router-link :to="{name:'Home'}">About</router-link>

            <SidebarYear v-for="workWithUniqueYear in worksWithUniqueYears" :year="workWithUniqueYear.year" :key="'year'+workWithUniqueYear.year"></SidebarYear>

        </div>
    </div>
</template>

<script>
    import SidebarYear from "./SidebarYear";
    import _ from 'lodash'

    export default {
        name: "Sidebar",
        components: {SidebarYear},
        mounted() {

        },
        computed: {
            worksWithUniqueYears: function () {
                var uniqueYears = _.uniqBy(this.$store.state.works, 'year')
                return _.orderBy(uniqueYears, 'year', 'desc')
            }
        }
    }
</script>

<style lang="scss">
    .sidebar {
        display: flex;
        justify-content: flex-end;
        padding-right: 1em;
        border-right: 1px solid gray;
    }

</style>